export enum AssetOperationType {
  Payin = 'payin',
  Payout = 'payout',
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
}
